const Home  = require('../animation/home');
const Utill = require('../utillity/utill')


module.exports.Init = function() {
	let $S = $('[data-home_slider]');
	if( !Utill.IsPage('home') ) return;
	if( $S.hasClass('is_setuped') ) return;

	if( Utill.IsOriginAnime() ) {
		$('#mainvisual .home-mv__slider').remove();
	}else {
		$('.section-bg .home-mv__slider').remove();
	}

	$S.slick({
		infinite: true,
		dots: false,
		speed: 1500,
		autoplaySpeed: 5500,
		centerMode: true,
		arrows: false,
		fade: true,
	});
	$S.addClass('is_setuped');

	// $S.on('afterChange',  Home.AfterChangeDeco);
	// $S.on('beforeChange', Home.BeforeChangeDeco);

};

module.exports.Start = function() {
	let $S = $('[data-home_slider]');
	if( !Utill.IsPage('home') ) return;
	if( $S.slick('slickCurrentSlide')===undefined ) {
		this.Init();
	}
	$S.slick('play');
};


module.exports.Break = function() {
	
	/*let $S = $('[data-home_slider]');
	$S.slick('unslick');*/
}


// WEBPACK FOOTER //
// ./html/_src/js_wb/animation/slider.js